import React from "react";
import { useTranslate } from "@refinedev/core";
import { TextField, Typography } from "@mui/material";
import { Controller } from "react-hook-form";

import { Modal } from "@shared/components";

import { PayReferralModalProps } from "./types";
import { usePayReferralModal } from "./controller";

export const PayReferralModal = React.memo(
  ({ modalRef, onComplete }: PayReferralModalProps) => {
    const translate = useTranslate();
    const { methods, mutateAsync, isPending } = usePayReferralModal(modalRef, onComplete);

    return (
      <Modal
        ref={modalRef}
        title={translate("referral_admin.titles.pay")}
        onConfirm={mutateAsync}
        methods={methods}
        isPending={isPending}
        confirmLabel={translate("referral_admin.buttons.confirm_pay")}
      >
        <Typography variant="body2" color="text.secondary" mb={2}>
          {translate("referral_admin.pay.description")}
        </Typography>

        <Controller
          name="custom_value_paid"
          control={methods.control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              value={field.value ?? ""}
              onChange={(e) => {
                const val = e.target.value;
                field.onChange(val === "" ? undefined : parseFloat(val));
              }}
              label={translate("referral_admin.fields.custom_value_paid")}
              type="number"
              fullWidth
              error={!!fieldState.error}
              helperText={
                fieldState.error?.message ??
                translate("referral_admin.pay.custom_value_hint")
              }
              slotProps={{ htmlInput: { min: 0, step: "0.01" } }}
            />
          )}
        />
      </Modal>
    );
  },
);
